/* eslint-disable */
import {
  assertNumber,
  distanceDimensionComponent,
  memoEval,
  sceneEntityObjectPropertiesComponent,
} from '@salsita-ai/platform-project-sdk/domain'

import { attachComponent } from '../implementation.js'

export const topWithDiameterComponents = [
  attachComponent
    .withComponent(sceneEntityObjectPropertiesComponent, 'top', true)
    .withAlias('TopWithDiameter')
    .attach(
      memoEval(
        // @ts-ignore
        self =>
          // keep deps on a separate line so @ts-ignore only covers the parameter
          [
            self.$offsetY,
            self.$thicknessValue,
            self.$thicknessScaleZero,
            self.$thicknessScaleOne,
            self.diameter,
            self.$widthScaleZero,
            self.$widthScaleOne,
            self.$lengthScaleZero,
            self.$lengthScaleOne,
            self.$distance,
            self.$distanceScaleZero,
            self.$distanceScaleOne,
            self.$leafBevel,
            self.$leafBevelScaleZero,
            self.$leafBevelScaleOne,
            self.$bevelThickness,
            self.$bevelScaleZero,
            self.$bevelScaleOne,
          ],
        (
          $offsetY,
          $thicknessValue,
          $thicknessScaleZero,
          $thicknessScaleOne,
          diameter,
          $widthScaleZero,
          $widthScaleOne,
          $lengthScaleZero,
          $lengthScaleOne,
          $distance,
          $distanceScaleZero,
          $distanceScaleOne,
          $leafBevel,
          $leafBevelScaleZero,
          $leafBevelScaleOne,
          $bevelThickness,
          $bevelScaleZero,
          $bevelScaleOne
        ) => ({
          offsetY: $offsetY,
          morphTargetInfluences: {
            thickness: {
              value: $thicknessValue,
              scaleZero: $thicknessScaleZero,
              scaleOne: $thicknessScaleOne,
            },
            width: {
              value: diameter,
              scaleZero: $widthScaleZero,
              scaleOne: $widthScaleOne,
            },
            length: {
              value: diameter,
              scaleZero: $lengthScaleZero,
              scaleOne: $lengthScaleOne,
            },
            distance: {
              value: $distance,
              scaleZero: $distanceScaleZero,
              scaleOne: $distanceScaleOne,
            },
            leafBevel: {
              value: $leafBevel,
              scaleZero: $leafBevelScaleZero,
              scaleOne: $leafBevelScaleOne,
            },
            bevel: {
              value: $bevelThickness,
              scaleZero: $bevelScaleZero,
              scaleOne: $bevelScaleOne,
            },
          },
        })
      )
    ),

  attachComponent
    .withComponent(distanceDimensionComponent, 'diameter', true)
    .withAlias('TopWithDiameter')
    .attach(
      memoEval(
        // @ts-ignore
        self =>
          // keep deps on a separate line so @ts-ignore only covers the parameter
          [self.diameter, self.$minWidth, self.$maxWidth],
        (diameter, $minWidth, $maxWidth) => ({
          value: diameter,
          min: $minWidth,
          max: $maxWidth,
        })
      ),
      state => {
        assertNumber(state.value)
        return { diameter: state.value }
      }
    ),
]
